(function () {
  const track = document.getElementById("marquee-track");

  if (!track) return;

  const content = track.innerHTML;
  const minCopies = 6;

  for (let i = 0; i < minCopies; i++) {
    track.innerHTML += content;
  }

  let position = 0;
  const speed = 1.2;

  let isPaused = false;

  // 👇 pause on hover
  track.addEventListener("mouseenter", () => {
    isPaused = true;
  });

  track.addEventListener("mouseleave", () => {
    isPaused = false;
  });

  function animate() {
    if (!isPaused) {
      position -= speed;

      if (Math.abs(position) >= track.scrollWidth / 2) {
        position = 0;
      }

      track.style.transform = `translateX(${position}px)`;
    }

    requestAnimationFrame(animate);
  }

  animate();
})();